"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Placeholder used by parent Image component, renders nothing on it's own.
 * @param type - type of placeholder 'blur'|'pixelate'|'predominant-color'|'vectorize',
 * @return {null}
 * @constructor
 */


var Placeholder = function Placeholder(_ref) {
  var type = _ref.type;
  return null;
};

Placeholder.propTypes = {
  type: _propTypes["default"].string
};
Placeholder.defaultProps = {
  type: 'blur'
};
Placeholder.displayName = "CloudinaryPlaceholder";
var _default = Placeholder;
exports["default"] = _default;